export const FUTURE_15_DAYS = "FUTURE_15_DAYS";
export const FUTURE_1_MONTH = "FUTURE_1_MONTH";
export const FUTURE_3_MONTHS = "FUTURE_3_MONTHS";
export const FUTURE_1_YEAR = "FUTURE_1_YEAR";
export const LATER_15_DAYS = "LATER_15_DAYS";
export const LATER_1_MONTH = "LATER_1_MONTH";
export const LATER_3_MONTHS = "LATER_3_MONTHS";
export const LATER_1_YEAR = "LATER_1_YEAR";
export const OLDER_15_DAYS = "OLDER_15_DAYS";
export const OLDER_1_MONTH = "OLDER_1_MONTH";
export const OLDER_3_MONTHS = "OLDER_3_MONTHS";
export const OLDER_1_YEAR = "OLDER_1_YEAR";
export const PAST_15_DAYS = "PAST_15_DAYS";
export const PAST_1_MONTH = "PAST_1_MONTH";
export const PAST_3_MONTHS = "PAST_3_MONTHS";
export const PAST_1_YEAR = "PAST_1_YEAR";

export const OPTIONS = {
  [FUTURE_15_DAYS]: "Next 15 Days",
  [FUTURE_1_MONTH]: "Next Month",
  [FUTURE_3_MONTHS]: "Next 3 Months",
  [FUTURE_1_YEAR]: "Next Year",
  [LATER_15_DAYS]: "Later Than 15 Days",
  [LATER_1_MONTH]: "Later Than 1 Month",
  [LATER_3_MONTHS]: "Later Than 3 Months",
  [LATER_1_YEAR]: "Later Than 1 Year",
  [OLDER_15_DAYS]: "Older Than 15 Days",
  [OLDER_1_MONTH]: "Older Than 1 Month",
  [OLDER_3_MONTHS]: "Older Than 3 Months",
  [OLDER_1_YEAR]: "Older Than 1 Year",
  [PAST_15_DAYS]: "Last 15 Days",
  [PAST_1_MONTH]: "Last Month",
  [PAST_3_MONTHS]: "Last 3 Months",
  [PAST_1_YEAR]: "Last Year",
};
